import api from './api';
import { Supplier, SupplierRequest } from '../types';

export const supplierAPI = {
    createSupplier: async (supplierData: SupplierRequest): Promise<Supplier> => {
        const response = await api.post<Supplier>('/suppliers', supplierData);
        return response.data;
    },

    getSuppliersByCompany: async (companyId: string): Promise<Supplier[]> => {
        const response = await api.get<Supplier[]>(`/suppliers/company/${companyId}`);
        return response.data;
    },

    getSupplierById: async (supplierId: string): Promise<Supplier> => {
        const response = await api.get<Supplier>(`/suppliers/${supplierId}`);
        return response.data;
    },

    updateSupplier: async (supplierId: string, supplierData: SupplierRequest): Promise<Supplier> => {
        const response = await api.put<Supplier>(`/suppliers/${supplierId}`, supplierData);
        return response.data;
    },

    deleteSupplier: async (supplierId: string): Promise<void> => {
        await api.delete(`/suppliers/${supplierId}`);
    },

    getNextSupplierNumber: async (companyId: string): Promise<number> => {
        const response = await api.get(`/suppliers/next-number?companyId=${companyId}`);
        return response.data;
    },
};
